<template>
  <div>

    <div class="toolbar">
      <span class="format">
        <button type="button" @mousedown.prevent="saveToolbarRange" @click="toggleStyle('b')">
          <svg viewBox="0 0 18 18">
            <path class="stroke"
                  d="M5,4H9.5A2.5,2.5,0,0,1,12,6.5v0A2.5,2.5,0,0,1,9.5,9H5A0,0,0,0,1,5,9V4A0,0,0,0,1,5,4Z"></path>
            <path class="stroke"
                  d="M5,9h5.5A2.5,2.5,0,0,1,13,11.5v0A2.5,2.5,0,0,1,10.5,14H5a0,0,0,0,1,0,0V9A0,0,0,0,1,5,9Z"></path>
          </svg>
        </button>
        <button type="button" @mousedown.prevent="saveToolbarRange" @click="toggleStyle('i')">
          <svg viewBox="0 0 18 18">
            <line class="stroke" x1="7" x2="13" y1="4" y2="4"></line>
            <line class="stroke" x1="5" x2="11" y1="14" y2="14"></line>
            <line class="stroke" x1="8" x2="10" y1="14" y2="4"></line>
          </svg>
        </button>
        <button type="button" @mousedown.prevent="saveToolbarRange" @click="toggleStyle('u')">
          <svg viewBox="0 0 18 18">
            <path class="stroke" d="M5,3V9a4.012,4.012,0,0,0,4,4H9a4.012,4.012,0,0,0,4-4V3"></path>
            <rect class="fill" height="1" rx="0.5" ry="0.5" width="12" x="3" y="15"></rect>
          </svg>
        </button>
        <button type="button" @mousedown.prevent="saveToolbarRange" @click="toggleStyle('s')">
          <svg viewBox="0 0 18 18">
            <line class="stroke thin" x1="15.5" x2="2.5" y1="8.5" y2="9.5"></line>
            <path class="fill"
                  d="M9.007,8C6.542,7.791,6,7.519,6,6.5,6,5.792,7.283,5,9,5c1.571,0,2.765.679,2.969,1.309a1,1,0,0,0,1.9-.617C13.356,4.106,11.354,3,9,3,6.2,3,4,4.538,4,6.5a3.2,3.2,0,0,0,.5,1.843Z"></path>
            <path class="fill"
                  d="M8.984,10C11.457,10.208,12,10.479,12,11.5c0,0.708-1.283,1.5-3,1.5-1.571,0-2.765-.679-2.969-1.309a1,1,0,1,0-1.9.617C4.644,13.894,6.646,15,9,15c2.8,0,5-1.538,5-3.5a3.2,3.2,0,0,0-.5-1.843Z"></path>
          </svg>
        </button>
        <button type="button" @mousedown.prevent="saveToolbarRange" @click="toggleStyle('sub')">
          <svg viewBox="0 0 18 18">
            <path class="fill"
                  d="M15.5,15H13.861a3.858,3.858,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.921,1.921,0,0,0,12.021,11.7a0.50013,0.50013,0,1,0,.957.291h0a0.914,0.914,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.076-1.16971,1.86982-1.93971,2.43082A1.45639,1.45639,0,0,0,12,15.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,15Z"></path>
            <path class="fill"
                  d="M9.65,5.241a1,1,0,0,0-1.409.108L6,7.964,3.759,5.349A1,1,0,0,0,2.192,6.59178Q2.21541,6.6213,2.241,6.649L4.684,9.5,2.241,12.35A1,1,0,0,0,3.71,13.70722q0.02557-.02768.049-0.05722L6,11.036,8.241,13.65a1,1,0,1,0,1.567-1.24277Q9.78459,12.3777,9.759,12.35L7.316,9.5,9.759,6.651A1,1,0,0,0,9.65,5.241Z"></path>
          </svg>
        </button>
        <button type="button" @mousedown.prevent="saveToolbarRange" @click="toggleStyle('sup')">
          <svg viewBox="0 0 18 18">
            <path class="fill"
                  d="M15.5,7H13.861a4.015,4.015,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.922,1.922,0,0,0,12.021,3.7a0.5,0.5,0,1,0,.957.291,0.917,0.917,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.077-1.164,1.925-1.934,2.486A1.423,1.423,0,0,0,12,7.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,7Z"></path>
            <path class="fill"
                  d="M9.651,5.241a1,1,0,0,0-1.41.108L6,7.964,3.759,5.349a1,1,0,1,0-1.519,1.3L4.683,9.5,2.241,12.35a1,1,0,1,0,1.519,1.3L6,11.036,8.241,13.65a1,1,0,0,0,1.519-1.3L7.317,9.5,9.759,6.651A1,1,0,0,0,9.651,5.241Z"></path> </svg>
        </button>
      </span>
      <span class="format">
        <span class="selector">
          <select v-model="fontValue" @mousedown="saveRange" @change="toggleStyle('span',  {'font-family': fontValue })">
            <option v-for="(font,i) in fonts" :key="i" :value="font.value"
                    :selected="font.value === headerValue">{{ font.label }}</option>
          </select>
        </span>
      </span>
      <span class="format">
        <span class="selector">
          <select v-model="fontSizeValue" @mousedown="saveRange" @change="toggleStyle('span', {'font-size': fontSizeValue})">
            <option v-for="(item,i) in fontSizes" :key="i" :value="item.value">{{ item.label }}</option>
          </select>
        </span>
      </span>
      <span class="format">
        <span class="selector">
          <select v-model="headerValue" @mousedown="saveRange" @change="toggleLineTag(headerValue)">
            <option v-for="(header,i) in headers" :key="i" :value="header.value"
                    :selected="header.value === headerValue">{{ header.label }}</option>
          </select>
        </span>
      </span>
      <span class="format">
        <span class="selector">
          <select v-model="alignValue" @mousedown="saveRange" @change="toggleLineStyle({'text-align': alignValue })">
            <option v-for="(align,i) in aligns" :key="i" :value="align.value"
                    :selected="align.value === alignValue">{{ align.label }}</option>
          </select>
        </span>
      </span>
      <span class="format color-picker-wrap" @mousedown.prevent="onColorPickerMouseDown">
        <el-color-picker
            v-model="fontColor"
            show-alpha
            popper-class="my-editor-color-popper"
            :predefine="predefineColors"
            @change="onFontColorChange"
        >
        </el-color-picker>
        <el-color-picker
            v-model="backgroundColor"
            show-alpha
            popper-class="my-editor-color-popper"
            :predefine="predefineColors"
            @change="onBackgroundColorChange"
        >
        </el-color-picker>
      </span>
      <span class="format">
        <button type="button" @click="onShowUploadImage">
          <svg viewBox="0 0 18 18">
            <rect class="stroke" height="10" width="12" x="3" y="4"></rect>
            <circle class="fill" cx="6" cy="7" r="1"></circle>
            <polyline class="even fill" points="5 12 5 11 7 9 8 10 11 7 13 9 13 12 5 12"></polyline>
          </svg>
        </button>
        <button type="button" @click="onShowUploadVideo">
          <svg viewBox="0 0 18 18">
            <rect class="stroke" height="12" width="12" x="3" y="3"></rect>
            <rect class="fill" height="12" width="1" x="5" y="3"></rect>
            <rect class="fill" height="12" width="1" x="12" y="3"></rect>
            <rect class="fill" height="2" width="8" x="5" y="8"></rect>
            <rect class="fill" height="1" width="3" x="3" y="5"></rect>
            <rect class="fill" height="1" width="3" x="3" y="7"></rect>
            <rect class="fill" height="1" width="3" x="3" y="10"></rect>
            <rect class="fill" height="1" width="3" x="3" y="12"></rect>
            <rect class="fill" height="1" width="3" x="12" y="5"></rect>
            <rect class="fill" height="1" width="3" x="12" y="7"></rect>
            <rect class="fill" height="1" width="3" x="12" y="10"></rect>
            <rect class="fill" height="1" width="3" x="12" y="12"></rect>
          </svg>
        </button>
      </span>
    </div>
    <div class="container" ref="editorContainer">
      <div
          ref="editor"
          class="editor"
          contenteditable="true"
          @mouseup="saveRange"
          @keyup="saveRange"
          @focus="saveRange"
          @blur="onEditorBlur"
          @paste="onEditorPaste"
          @input="contentInput"
          @keydown="onEditorKeyDown"
          @scroll="updateImageHandlePosition"
      >
        <div><br></div>
      </div>
      <div
          v-show="selectedImage"
          ref="imageResizeHandle"
          class="image-resize-handle"
          title="拖拽等比缩放"
          @mousedown.prevent.stop="onImageResizeStart"
      ></div>
    </div>


    <dialog-upload-image
        ref="dialogUploadImage"
        :dialog="DialogUploadImage"
        @insert-node="onImageDialogInsert"
        @image-updated="onImageUpdated"
        @closed="onImageDialogClosed"
    ></dialog-upload-image>
    <dialog-upload-video
      :dialog="DialogUploadVideo"
      @insert-node="insertNode"
        ></dialog-upload-video>

  </div>
</template>
<script>


import DialogUploadImage from "@/components/dialog/MyEditor/DialogUploadImage.vue";
import DialogUploadVideo from "@/components/dialog/MyEditor/DialogUploadVideo.vue";
import { generateUUID } from "@/utils/UUIDUtils";

const SEMANTIC_COMMAND_MAP = {
  b: 'bold',
  i: 'italic',
  u: 'underline',
  s: 'strikeThrough',
  sub: 'subscript',
  sup: 'superscript',
}
const INLINE_TAG_ALIASES = {
  b: ['B', 'STRONG'],
  i: ['I', 'EM'],
  u: ['U'],
  s: ['S', 'STRIKE', 'DEL'],
  sub: ['SUB'],
  sup: ['SUP'],
}
const HEADER_BLOCK_TAGS = ['DIV', 'P', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6']
const SPECIAL_BLOCK_CLASSES = ['card-score-link', 'resource-collections']
const COLOR_PICKER_POPPER_CLASS = 'my-editor-color-popper'
const FONT_SIZES = [
  { value: '默认', label: '字号' },
  ...Array.from({ length: 89 }, (_, index) => {
    const size = index + 12
    return { value: `${size}px`, label: String(size) }
  }),
]

export default {
  name: "MyEditor",
  components: {DialogUploadVideo, DialogUploadImage},
  data() {
    return {
      savedRange: null,
      savedColorRange: null,
      colorPickerLock: false,

      fontValue: '默认',
      fonts: [
        {
          value: '默认',
          label: '默认',
        },
        {
          value: 'Arial',
          label: 'Arial',
        },
        {
          value: 'SimSun',
          label: 'SimSun',
        },
        {
          value: 'SimHei',
          label: 'SimHei',
        },
        {
          value: 'sans-serif',
          label: 'sans-serif',
        },
        {
          value: '黑体',
          label: '黑体',
        },
        {
          value: 'AdobeHeitiStd-Regular',
          label: '黑体常规',
        },
        {
          value: '宋体',
          label: '宋体',
        },
        {
          value: 'FangSong',
          label: '仿宋',
        },
        {
          value: 'AdobeFangsongStd-Regular',
          label: '仿宋常规',
        },
        {
          value: 'AdobeSongStd-Light',
          label: '宋体淡',
        },
        {
          value: 'KaiTi',
          label: '楷体',
        },
        {
          value: 'AdobeKaitiStd-Regular',
          label: '楷体常规',
        },
        {
          value: 'Microsoft-YaHei',
          label: '微软雅黑',
        },
        {
          value: 'Times-New-Roman',
          label: '罗马',
        },
        {
          value: 'RosewoodStd-Regular',
          label: '艺术(英) 粗',
        },
        {
          value: '汉仪喵魂梦境 W',
          label: '汉仪喵魂梦境 W',
        },
        {
          value: '草书1',
          label: '草书1',
        },
      ],
      fontSizeValue: '默认',
      fontSizes: FONT_SIZES,
      headerValue: "正文",
      headers: [
        {
          value: "正文",
          label: "正文"
        },
        {
          value: "h1",
          label: "标题1"
        },
        {
          value: "h2",
          label: "标题2"
        },
        {
          value: "h3",
          label: "标题3"
        },
        {
          value: "h4",
          label: "标题4"
        },
        {
          value: "h5",
          label: "标题5"
        },
        {
          value: "h6",
          label: "标题6"
        },
      ],
      alignValue: "left",
      aligns: [
        {
          value: "left",
          label: "左对齐"
        },
        {
          value: "center",
          label: "居中"
        },
        {
          value: "right",
          label: "右对齐"
        }
      ],

      fontColor: '#000000',
      backgroundColor: '',
      predefineColors: [
        '#000000',
        '#ffffff',
        '#ff4500',
        '#ff8c00',
        '#ffd700',
        '#90ee90',
        '#00ced1',
        '#1e90ff',
        '#c71585',
        'rgba(255, 69, 0, 0.68)',
        'rgba(255, 255, 255, 0)',
      ],


      DialogUploadImage: false,
      DialogUploadVideo: false,
      pasteImageQueue: [],
      selectedImage: null,
      imageResizeListenersBound: false,

    }
  },
  mounted() {
    this.bindEditorEvents()
    this.normalizeSpecialBlocks()
    this.onColorPopperMouseDown = (event) => {
      if (event.target.closest(`.${COLOR_PICKER_POPPER_CLASS}`)) {
        event.preventDefault()
        this.colorPickerLock = true
      }
    }
    this.onDocumentMouseDown = (event) => {
      if (event.target.closest(`.${COLOR_PICKER_POPPER_CLASS}`)) {
        return
      }
      if (!event.target.closest('.color-picker-wrap')) {
        this.colorPickerLock = false
      }
    }
    document.addEventListener('mousedown', this.onColorPopperMouseDown, true)
    document.addEventListener('mousedown', this.onDocumentMouseDown, true)
  },
  beforeDestroy() {
    document.removeEventListener('mousedown', this.onColorPopperMouseDown, true)
    document.removeEventListener('mousedown', this.onDocumentMouseDown, true)
    this.unbindImageResizeListeners()
    this.clearSelectedImage()
  },
  methods: {
    getEditorEl() {
      return this.$refs.editor
    },
    isSpecialBlockTarget(target) {
      if (!target || !target.closest) {
        return false
      }
      return !!target.closest('.card-score-link, .resource-collections, a.card-score-link, a.resource-collections')
    },
    normalizeSpecialBlocks() {
      const editor = this.getEditorEl()
      if (!editor) {
        return
      }
      editor.querySelectorAll('.card-score-link, .resource-collections').forEach(block => {
        block.contentEditable = 'false'
      })
      editor.querySelectorAll('a.card-score-link, a.resource-collections').forEach(link => {
        link.contentEditable = 'false'
      })
    },
    focusEditor() {
      const editor = this.getEditorEl()
      if (!editor) {
        return
      }
      editor.focus()
      if (this.savedRange) {
        const selection = window.getSelection()
        selection.removeAllRanges()
        selection.addRange(this.savedRange.cloneRange())
      }
    },
    bindEditorEvents() {
      const editor = this.getEditorEl()
      if (!editor || editor._myEditorBound) {
        return
      }
      editor._myEditorBound = true
      editor.addEventListener('mousedown', (event) => {
        if (this.isSpecialBlockTarget(event.target)) {
          event.preventDefault()
        }
      })
      editor.addEventListener('click', (event) => {
        let linkTarget = event.target.closest('a.card-score-link, a.resource-collections')
        if (!linkTarget) {
          const block = event.target.closest('.card-score-link, .resource-collections')
          if (block) {
            linkTarget = block.querySelector('a.card-score-link, a.resource-collections')
          }
        }
        if (linkTarget) {
          event.preventDefault()
          event.stopPropagation()
          this.normalizeSpecialBlocks()
          window.getSelection().removeAllRanges()
          if (linkTarget.classList.contains('card-score-link')) {
            this.$emit('cardScoreLinkClickListener', linkTarget)
          } else {
            this.$emit('resourceCollectionsClickListener', linkTarget)
          }
          return
        }
        const img = event.target.closest('img')
        if (img && editor.contains(img)) {
          event.preventDefault()
          event.stopPropagation()
          if (this.selectedImage === img) {
            this.openImageEdit(img)
          } else {
            this.selectImage(img)
          }
          return
        }
        this.clearSelectedImage()
      })
    },
    selectImage(img) {
      if (this.selectedImage === img) {
        this.updateImageHandlePosition()
        return
      }
      this.clearSelectedImage(false)
      this.selectedImage = img
      img.classList.add('my-editor-img-selected')
      this.bindImageResizeListeners()
      this.$nextTick(() => {
        this.updateImageHandlePosition()
      })
    },
    clearSelectedImage(unbindListeners = true) {
      if (this.selectedImage) {
        this.selectedImage.classList.remove('my-editor-img-selected')
        this.selectedImage = null
      }
      if (unbindListeners) {
        this.unbindImageResizeListeners()
      }
    },
    bindImageResizeListeners() {
      if (this.imageResizeListenersBound) {
        return
      }
      this.onWindowResizeForImage = () => {
        this.updateImageHandlePosition()
      }
      window.addEventListener('resize', this.onWindowResizeForImage)
      this.imageResizeListenersBound = true
    },
    unbindImageResizeListeners() {
      if (!this.imageResizeListenersBound) {
        return
      }
      window.removeEventListener('resize', this.onWindowResizeForImage)
      this.imageResizeListenersBound = false
    },
    updateImageHandlePosition() {
      const img = this.selectedImage
      const container = this.$refs.editorContainer
      const handle = this.$refs.imageResizeHandle
      if (!img || !container || !handle) {
        return
      }
      const imgRect = img.getBoundingClientRect()
      const containerRect = container.getBoundingClientRect()
      const handleSize = 10
      handle.style.left = `${imgRect.right - containerRect.left - handleSize / 2}px`
      handle.style.top = `${imgRect.bottom - containerRect.top - handleSize / 2}px`
    },
    openImageEdit(img) {
      this.pasteImageQueue = []
      this.DialogUploadImage = true
      this.$nextTick(() => {
        if (this.$refs.dialogUploadImage) {
          this.$refs.dialogUploadImage.prepareEdit(img)
        }
      })
    },
    onImageUpdated(img) {
      if (this.selectedImage === img) {
        this.$nextTick(() => {
          this.updateImageHandlePosition()
        })
      }
    },
    onImageResizeStart(event) {
      const img = this.selectedImage
      const editor = this.getEditorEl()
      if (!img || !editor) {
        return
      }
      const editorWidth = editor.clientWidth
      const startX = event.clientX
      const startWidthPx = img.getBoundingClientRect().width
      const onMove = (moveEvent) => {
        const deltaX = moveEvent.clientX - startX
        const newWidthPx = Math.max(20, startWidthPx + deltaX)
        const newWidthPercent = Math.min(100, Math.max(5, (newWidthPx / editorWidth) * 100))
        img.style.width = `${newWidthPercent}%`
        img.style.removeProperty('height')
        img.style.removeProperty('aspect-ratio')
        this.updateImageHandlePosition()
      }
      const onUp = () => {
        document.removeEventListener('mousemove', onMove)
        document.removeEventListener('mouseup', onUp)
      }
      document.addEventListener('mousemove', onMove)
      document.addEventListener('mouseup', onUp)
    },
    ensureEditorStructure() {
      const editor = this.getEditorEl()
      if (!editor) {
        return
      }
      if (!editor.childNodes.length) {
        editor.innerHTML = '<div><br></div>'
      }
    },
    createEmptyLineDiv() {
      const div = document.createElement('div')
      div.innerHTML = '<br>'
      return div
    },
    ensureBlockNotEmpty(block) {
      if (!block) {
        return
      }
      if (!block.textContent && !block.querySelector('img, br, svg, a')) {
        block.innerHTML = '<br>'
      }
    },
    placeCursorAtBlockStart(block) {
      const selection = window.getSelection()
      const range = document.createRange()
      range.setStart(block, 0)
      range.collapse(true)
      selection.removeAllRanges()
      selection.addRange(range)
      this.savedRange = range.cloneRange()
    },
    onEditorKeyDown(event) {
      if (event.key !== 'Enter') {
        return
      }
      const editor = this.getEditorEl()
      const selection = window.getSelection()
      if (!editor || !selection.rangeCount) {
        return
      }
      const range = selection.getRangeAt(0)
      if (!editor.contains(range.commonAncestorContainer)) {
        return
      }
      event.preventDefault()
      if (!range.collapsed) {
        range.deleteContents()
      }
      this.insertNewLineDiv(range, editor)
    },
    insertNewLineDiv(range, editor) {
      const lineBlock = this.getLineBlockNode(range, editor)
      if (!lineBlock || lineBlock.parentNode !== editor || !this.isHeaderBlock(lineBlock)) {
        const newDiv = this.createEmptyLineDiv()
        if (lineBlock && lineBlock.parentNode === editor) {
          editor.insertBefore(newDiv, lineBlock.nextSibling)
        } else {
          editor.appendChild(newDiv)
        }
        this.placeCursorAtBlockStart(newDiv)
        return
      }
      const afterRange = range.cloneRange()
      afterRange.selectNodeContents(lineBlock)
      afterRange.setStart(range.endContainer, range.endOffset)
      const afterFragment = afterRange.extractContents()
      const newDiv = this.createEmptyLineDiv()
      if (afterFragment.textContent || afterFragment.querySelector('img, br, svg, a')) {
        newDiv.innerHTML = ''
        newDiv.appendChild(afterFragment)
      }
      this.ensureBlockNotEmpty(lineBlock)
      editor.insertBefore(newDiv, lineBlock.nextSibling)
      this.ensureBlockNotEmpty(newDiv)
      this.placeCursorAtBlockStart(newDiv)
    },
    getContent() {
      const editor = this.getEditorEl()
      if (!editor) {
        return ''
      }
      return this.sanitizeEditorHtml(editor.innerHTML)
    },
    sanitizeEditorHtml(html) {
      if (!html) {
        return ''
      }
      return html
        .replace(/\scontenteditable="(?:true|false)"/gi, '')
        .replace(/\scontenteditable='(?:true|false)'/gi, '')
        .replace(/\sdata-v-[a-f0-9]+="[^"]*"/gi, '')
        .replace(/<div>\s*<\/div>/gi, '')
    },
    setContent(content) {
      const editor = this.getEditorEl()
      if (!editor) {
        return
      }
      editor.innerHTML = content || '<div><br></div>'
      this.clearSelectedImage()
      this.bindEditorEvents()
      this.normalizeSpecialBlocks()
    },
    contentInput(event) {
      const editor = event.target
      if (!editor) {
        return
      }
      Array.from(editor.childNodes).forEach(child => {
        if (child.nodeType === Node.TEXT_NODE && child.textContent.trim()) {
          const divNode = document.createElement('div')
          divNode.textContent = child.textContent
          editor.replaceChild(divNode, child)
        } else if (child.nodeType === Node.ELEMENT_NODE && child.tagName === 'P') {
          const divNode = document.createElement('div')
          divNode.innerHTML = child.innerHTML
          editor.replaceChild(divNode, child)
        } else if (child.nodeType === Node.ELEMENT_NODE && child.tagName === 'BR') {
          const divNode = this.createEmptyLineDiv()
          editor.replaceChild(divNode, child)
        }
      })
      this.ensureEditorStructure()
      this.normalizeSpecialBlocks()
    },
    onEditorPaste(event) {
      const clipboardData = event.clipboardData
      if (!clipboardData) {
        return
      }
      this.saveRange()
      const html = clipboardData.getData('text/html')
      const imageItems = Array.from(clipboardData.items || []).filter(item => item.type.indexOf('image') === 0)
      const base64Sources = html ? this.extractBase64ImagesFromHtml(html) : []
      if (!imageItems.length && !base64Sources.length) {
        this.$nextTick(() => {
          this.handlePastedBase64ImagesInEditor()
        })
        return
      }
      event.preventDefault()
      if (html) {
        const cleanedHtml = this.removeImagesFromHtml(html)
        if (this.hasPasteTextContent(cleanedHtml)) {
          this.insertPastedHtmlWithoutImages(cleanedHtml)
        }
      }
      const files = []
      imageItems.forEach(item => {
        const file = item.getAsFile()
        if (file) {
          files.push(file)
        }
      })
      base64Sources.forEach((dataUrl, index) => {
        files.push(this.dataURLtoFile(dataUrl, `paste-${index}-${generateUUID()}.png`))
      })
      if (files.length) {
        this.openPasteImageQueue(files)
      }
    },
    extractBase64ImagesFromHtml(html) {
      const doc = new DOMParser().parseFromString(html, 'text/html')
      const sources = []
      doc.querySelectorAll('img[src^="data:image"]').forEach(img => {
        sources.push(img.getAttribute('src'))
      })
      return sources
    },
    removeImagesFromHtml(html) {
      const doc = new DOMParser().parseFromString(html, 'text/html')
      doc.querySelectorAll('img').forEach(img => img.remove())
      return doc.body.innerHTML
    },
    hasPasteTextContent(html) {
      const doc = new DOMParser().parseFromString(html, 'text/html')
      return !!(doc.body.textContent || '').trim()
    },
    insertPastedHtmlWithoutImages(html) {
      const selection = window.getSelection()
      const editor = this.getEditorEl()
      if (!editor || !selection.rangeCount) {
        return
      }
      const range = selection.getRangeAt(0)
      if (!editor.contains(range.commonAncestorContainer)) {
        return
      }
      range.deleteContents()
      const template = document.createElement('template')
      template.innerHTML = html
      range.insertNode(template.content)
      range.collapse(false)
      selection.removeAllRanges()
      selection.addRange(range)
      this.savedRange = range.cloneRange()
      this.ensureEditorStructure()
    },
    handlePastedBase64ImagesInEditor() {
      const editor = this.getEditorEl()
      if (!editor) {
        return
      }
      const images = Array.from(editor.querySelectorAll('img[src^="data:image"]'))
      if (!images.length) {
        return
      }
      const files = images.map((img, index) => this.dataURLtoFile(
        img.getAttribute('src'),
        `paste-${index}-${generateUUID()}.png`
      ))
      images.forEach(img => img.remove())
      this.openPasteImageQueue(files)
    },
    openPasteImageQueue(files) {
      if (!files.length) {
        return
      }
      this.pasteImageQueue = files.slice(1)
      this.openImageDialogWithFile(files[0])
    },
    openImageDialogWithFile(file) {
      this.DialogUploadImage = true
      this.$nextTick(() => {
        if (this.$refs.dialogUploadImage) {
          this.$refs.dialogUploadImage.preparePasteFile(file)
        }
      })
    },
    onImageDialogInsert(node) {
      this.insertNode(node)
      const pendingFiles = this.pasteImageQueue.slice()
      this.pasteImageQueue = []
      if (pendingFiles.length) {
        this.openPasteImageQueue(pendingFiles)
      }
    },
    onImageDialogClosed() {
      this.pasteImageQueue = []
    },
    dataURLtoFile(dataUrl, filename) {
      const parts = dataUrl.split(',')
      const mimeMatch = parts[0].match(/:(.*?);/)
      const mime = mimeMatch ? mimeMatch[1] : 'image/png'
      const binary = atob(parts[1])
      const bytes = new Uint8Array(binary.length)
      for (let i = 0; i < binary.length; i += 1) {
        bytes[i] = binary.charCodeAt(i)
      }
      return new File([bytes], filename, { type: mime })
    },
    insertNode(node) {
      const editor = this.getEditorEl()
      if (!editor || !node) {
        return
      }
      if (this.isEditorBlockNode(node)) {
        this.insertEditorBlockNode(node)
        return
      }
      const selection = window.getSelection()
      if (this.savedRange) {
        selection.removeAllRanges()
        selection.addRange(this.savedRange)
      }
      if (!selection.rangeCount) {
        editor.appendChild(node)
        return
      }
      const range = selection.getRangeAt(0)
      if (!editor.contains(range.commonAncestorContainer)) {
        editor.appendChild(node)
      } else {
        range.insertNode(node)
        range.setStartAfter(node)
        range.collapse(true)
        selection.removeAllRanges()
        selection.addRange(range)
        this.savedRange = range.cloneRange()
      }
    },
    isEditorBlockNode(node) {
      if (!node || node.nodeType !== Node.ELEMENT_NODE || node.tagName !== 'DIV') {
        return false
      }
      if (SPECIAL_BLOCK_CLASSES.some(className => node.classList.contains(className))) {
        return true
      }
      if (node.querySelector('img, video')) {
        return true
      }
      return !!node.querySelector(
        'a.card-score-link, a.resource-collections, a.wechatmp-link, a.shipinhaoindex-link, a.shipinhao-link'
      )
    },
    isEmptyLineBlock(block) {
      if (!block || block.nodeType !== Node.ELEMENT_NODE || block.tagName !== 'DIV') {
        return false
      }
      if (SPECIAL_BLOCK_CLASSES.some(className => block.classList.contains(className))) {
        return false
      }
      if (block.querySelector('img, video, a, svg')) {
        return false
      }
      return !block.textContent
    },
    insertEditorBlockNode(node) {
      const editor = this.getEditorEl()
      const selection = window.getSelection()
      if (this.savedRange) {
        selection.removeAllRanges()
        selection.addRange(this.savedRange)
      }
      let inserted = false
      if (selection.rangeCount) {
        const range = selection.getRangeAt(0)
        if (editor.contains(range.commonAncestorContainer)) {
          const lineBlock = this.getLineBlockNode(range, editor)
          if (lineBlock && lineBlock.parentNode === editor) {
            if (this.isEmptyLineBlock(lineBlock)) {
              editor.replaceChild(node, lineBlock)
            } else {
              editor.insertBefore(node, lineBlock.nextSibling)
            }
            inserted = true
          }
        }
      }
      if (!inserted) {
        editor.appendChild(node)
      }
      const emptyLine = this.createEmptyLineDiv()
      if (node.nextSibling) {
        editor.insertBefore(emptyLine, node.nextSibling)
      } else {
        editor.appendChild(emptyLine)
      }
      this.placeCursorAtBlockStart(emptyLine)
      this.ensureEditorStructure()
      this.normalizeSpecialBlocks()
    },
    onShowUploadImage() {
      this.pasteImageQueue = []
      this.clearSelectedImage()
      this.DialogUploadImage = true
      this.$nextTick(() => {
        if (this.$refs.dialogUploadImage) {
          this.$refs.dialogUploadImage.resetForm()
        }
      })
    },
    onShowUploadVideo(){
      this.DialogUploadVideo = true;
    },
    saveRange() {
      if (this.colorPickerLock) {
        return
      }
      const selection = window.getSelection()
      const container = this.getEditorEl()
      if (!container || selection.rangeCount === 0) {
        return
      }
      const range = selection.getRangeAt(0)
      if (container.contains(range.commonAncestorContainer)) {
        this.savedRange = range.cloneRange()
        this.syncToolbarColors()
      }
    },
    saveToolbarRange() {
      if (this.colorPickerLock) {
        return
      }
      const selection = window.getSelection()
      const container = this.getEditorEl()
      if (!container || selection.rangeCount === 0) {
        return
      }
      const range = selection.getRangeAt(0)
      if (container.contains(range.commonAncestorContainer) && !range.collapsed) {
        this.savedRange = range.cloneRange()
        this.syncToolbarColors()
      }
    },
    onEditorBlur(event) {
      if (this.colorPickerLock) {
        return
      }
      const relatedTarget = event.relatedTarget
      if (relatedTarget && relatedTarget.closest && relatedTarget.closest(`.${COLOR_PICKER_POPPER_CLASS}`)) {
        return
      }
      this.saveRange()
    },
    captureColorSelection() {
      const selection = window.getSelection()
      const container = this.getEditorEl()
      if (!container || selection.rangeCount === 0) {
        return
      }
      const range = selection.getRangeAt(0)
      if (!container.contains(range.commonAncestorContainer) || range.collapsed) {
        return
      }
      this.savedColorRange = range.cloneRange()
      this.savedRange = range.cloneRange()
      this.colorPickerLock = true
    },
    restoreColorSelection() {
      const editor = this.getEditorEl()
      if (!editor) {
        return
      }
      editor.focus()
      const range = this.savedColorRange || this.savedRange
      if (!range) {
        return
      }
      const selection = window.getSelection()
      selection.removeAllRanges()
      selection.addRange(range.cloneRange())
    },
    releaseColorPickerLock() {
      this.colorPickerLock = false
      this.savedColorRange = null
    },
    onColorPickerMouseDown() {
      this.captureColorSelection()
    },
    onFontColorChange(color) {
      this.applyInlineColorStyle('color', color)
    },
    onBackgroundColorChange(color) {
      this.applyInlineColorStyle('background-color', color)
    },
    applyInlineColorStyle(styleKey, color) {
      const colorRange = this.savedColorRange || this.savedRange
      if (!colorRange || colorRange.collapsed) {
        this.$message.warning('请先选中文字')
        this.releaseColorPickerLock()
        return
      }
      this.restoreColorSelection()
      const selection = window.getSelection()
      if (!selection.rangeCount || !this.hasSelection(selection)) {
        this.$message.warning('请先选中文字')
        this.releaseColorPickerLock()
        return
      }
      const range = selection.getRangeAt(0)
      const container = this.getEditorEl()
      if (!container || !container.contains(range.commonAncestorContainer)) {
        this.releaseColorPickerLock()
        return
      }
      if (color == null || color === '') {
        this.unwrapStyledText(range, 'span', { [styleKey]: '' })
      } else {
        this.applyColorStyleToRange(range, styleKey, color)
      }
      this.releaseColorPickerLock()
      this.saveRange()
    },
    applyColorStyleToRange(range, styleKey, color) {
      const container = this.getEditorEl()
      const rangeBounds = this.captureRangeTextBounds(range)
      const selectedText = range.toString()
      if (selectedText) {
        const textNodes = this.getTextNodesInRange(range)
        if (textNodes.length) {
          let targetSpan = null
          let el = textNodes[0].parentElement
          while (el && el !== container) {
            if (el.tagName === 'SPAN'
                && el.textContent === selectedText
                && textNodes.every(node => el.contains(node))) {
              targetSpan = el
            }
            el = el.parentElement
          }
          if (targetSpan) {
            const styles = { [styleKey]: color }
            this.stripStylesFromDescendants(targetSpan, styles)
            this.applyInlineStyles(targetSpan, styles)
            this.applyRangeTextBounds(rangeBounds)
            return
          }
        }
      }
      this.wrapStyledText(range, 'span', { [styleKey]: color })
    },
    removeInlineStyleInRange(styleKey) {
      this.applyInlineColorStyle(styleKey, '')
    },
    getStyleAtCursor(styleKey) {
      const container = this.getEditorEl()
      if (!container || !this.savedRange) {
        return null
      }
      let node = this.savedRange.startContainer
      if (node.nodeType === Node.TEXT_NODE) {
        node = node.parentElement
      } else if (node.nodeType === Node.ELEMENT_NODE && this.savedRange.startOffset > 0) {
        node = node.childNodes[this.savedRange.startOffset - 1] || node
        if (node.nodeType === Node.TEXT_NODE) {
          node = node.parentElement
        }
      }
      const prop = this.toCssProperty(styleKey)
      while (node && node !== container) {
        const value = node.style && node.style.getPropertyValue(prop)
        if (value) {
          return value
        }
        node = node.parentElement
      }
      return null
    },
    syncToolbarColors() {
      if (!this.savedRange || this.savedRange.collapsed) {
        return
      }
      const color = this.getStyleAtCursor('color')
      if (color) {
        this.fontColor = color
      }
      const backgroundColor = this.getStyleAtCursor('background-color')
      if (backgroundColor) {
        this.backgroundColor = backgroundColor
      }
    },
    // 切换选中行样式
    toggleLineStyle(styles) {
      this.restoreSelection()
      const selection = window.getSelection()
      if (!selection.rangeCount) {
        return
      }
      const range = selection.getRangeAt(0)
      const container = this.getEditorEl()
      if (!container || !container.contains(range.commonAncestorContainer)) {
        return
      }
      const lineBlock = this.getLineBlockNode(range, container)
      if (!this.isHeaderBlock(lineBlock)) {
        return
      }
      this.addLineStyle(lineBlock, styles)
      this.placeCursorInBlock(lineBlock)
    },
    addLineStyle(node, styles) {
      Object.entries(styles).forEach(([key, value]) => {
        const prop = key.replace(/([A-Z])/g, '-$1').toLowerCase()
        if (value == null || value === '') {
          node.style.removeProperty(prop)
        } else {
          node.style.setProperty(prop, value)
        }
      })
      return node
    },
    // 切换选中行标签和样式
    getLineBlockNode(range, container) {
      let node = range.startContainer
      if (node === container) {
        const children = container.childNodes
        if (!children.length) {
          return null
        }
        const offset = range.startOffset
        return children[offset] || children[offset - 1] || children[0]
      }
      if (node.nodeType === Node.TEXT_NODE) {
        node = node.parentNode
      }
      while (node && node !== container) {
        if (node.parentNode === container) {
          return node
        }
        node = node.parentNode
      }
      return null
    },
    isHeaderBlock(node) {
      if (!node || node.nodeType !== Node.ELEMENT_NODE) {
        return false
      }
      if (!HEADER_BLOCK_TAGS.includes(node.tagName)) {
        return false
      }
      return !SPECIAL_BLOCK_CLASSES.some(className => node.classList.contains(className))
    },
    placeCursorInBlock(block) {
      const selection = window.getSelection()
      const range = document.createRange()
      range.selectNodeContents(block)
      range.collapse(false)
      selection.removeAllRanges()
      selection.addRange(range)
      this.savedRange = range.cloneRange()
    },
    toggleLineTag(tagName) {
      const normalizedTag = tagName === '正文' ? 'div' : tagName
      this.restoreSelection()
      const selection = window.getSelection()
      if (!selection.rangeCount) {
        return
      }
      const range = selection.getRangeAt(0)
      const container = this.getEditorEl()
      if (!container || !container.contains(range.commonAncestorContainer)) {
        return
      }
      const lineBlock = this.getLineBlockNode(range, container)
      if (!this.isHeaderBlock(lineBlock)) {
        return
      }
      if (lineBlock.tagName.toLowerCase() === normalizedTag.toLowerCase()) {
        return
      }
      const newElement = this.toggleTag(lineBlock, normalizedTag)
      container.replaceChild(newElement, lineBlock)
      this.placeCursorInBlock(newElement)
    },
    toggleTag(node, tagName) {
      const tagElement = document.createElement(tagName)
      tagElement.innerHTML = node.innerHTML
      if (node.style && node.style.cssText) {
        tagElement.style.cssText = node.style.cssText
      }
      if (node.className) {
        tagElement.className = node.className
      }
      return tagElement
    },

    // 切换选中文本样式
    restoreSelection() {
      const selection = window.getSelection()
      const editor = this.getEditorEl()
      if (!editor) {
        return
      }
      editor.focus()
      if (this.savedRange) {
        selection.removeAllRanges()
        selection.addRange(this.savedRange)
      }
    },
    setSelectionRange(range) {
      if (!range) {
        return
      }
      const editor = this.getEditorEl()
      if (editor) {
        editor.focus()
      }
      const selection = window.getSelection()
      selection.removeAllRanges()
      selection.addRange(range)
      this.savedRange = range.cloneRange()
    },
    captureRangeTextBounds(range) {
      const textNodes = this.getTextNodesInRange(range)
      if (!textNodes.length) {
        return { fallbackRange: range.cloneRange() }
      }
      const startNode = textNodes[0]
      const endNode = textNodes[textNodes.length - 1]
      return {
        startNode,
        endNode,
        startOffset: range.startContainer === startNode
          ? range.startOffset
          : 0,
        endOffset: range.endContainer === endNode
          ? range.endOffset
          : endNode.textContent.length,
      }
    },
    applyRangeTextBounds(bounds) {
      if (!bounds) {
        return
      }
      if (bounds.fallbackRange) {
        this.setSelectionRange(bounds.fallbackRange)
        return
      }
      const { startNode, endNode, startOffset, endOffset } = bounds
      if (!startNode || !endNode || !startNode.isConnected || !endNode.isConnected) {
        return
      }
      const range = document.createRange()
      range.setStart(startNode, Math.min(startOffset, startNode.textContent.length))
      range.setEnd(endNode, Math.min(endOffset, endNode.textContent.length))
      this.setSelectionRange(range)
    },
    selectNodeContents(node) {
      if (!node) {
        return
      }
      const range = document.createRange()
      range.selectNodeContents(node)
      this.setSelectionRange(range)
    },
    restoreRangeFromTextNodes(originalRange) {
      this.applyRangeTextBounds(this.captureRangeTextBounds(originalRange))
    },
    getTextNodesInRange(range) {
      const editor = this.getEditorEl()
      if (!editor || !range) {
        return []
      }
      const nodes = []
      const walker = document.createTreeWalker(editor, NodeFilter.SHOW_TEXT, {
        acceptNode: (node) => {
          if (!node.textContent || !node.textContent.length) {
            return NodeFilter.FILTER_REJECT
          }
          if (!range.intersectsNode(node)) {
            return NodeFilter.FILTER_REJECT
          }
          return NodeFilter.FILTER_ACCEPT
        },
      })
      let node
      while ((node = walker.nextNode())) {
        nodes.push(node)
      }
      return nodes
    },
    toCssProperty(key) {
      return key.replace(/([A-Z])/g, '-$1').toLowerCase()
    },
    normalizeStyleValue(key, value) {
      if (value == null || value === '') {
        return ''
      }
      const prop = this.toCssProperty(key)
      if (prop === 'color' || prop === 'background-color') {
        return this.normalizeColor(value, prop)
      }
      if (prop === 'font-family') {
        return String(value).replace(/['"]/g, '').trim().toLowerCase()
      }
      return String(value).replace(/\s/g, '').toLowerCase()
    },
    normalizeColor(value, prop = 'color') {
      const el = document.createElement('span')
      el.style.setProperty(prop, value)
      return el.style.getPropertyValue(prop).replace(/\s/g, '').toLowerCase()
    },
    matchesTagName(el, tagName) {
      if (!tagName || !el || !el.tagName) {
        return false
      }
      const aliases = INLINE_TAG_ALIASES[tagName.toLowerCase()]
      if (aliases) {
        return aliases.includes(el.tagName)
      }
      return el.tagName === tagName.toUpperCase()
    },
    elementMatchesStyles(el, styles) {
      if (!el || !el.style || !styles || !Object.keys(styles).length) {
        return false
      }
      return Object.entries(styles).every(([key, value]) => {
        if (value == null || value === '' || value === '默认') {
          return true
        }
        const expected = this.normalizeStyleValue(key, value)
        const current = this.normalizeStyleValue(
          key,
          el.style.getPropertyValue(this.toCssProperty(key)) || el.style[key]
        )
        return current === expected
      })
    },
    findStyleElement(textNode, tagName, styles, container) {
      let el = textNode.parentElement
      const hasStyles = styles && Object.keys(styles).length > 0
      while (el && el !== container) {
        if (hasStyles) {
          if (this.elementMatchesStyles(el, styles)) {
            return el
          }
        } else if (tagName && this.matchesTagName(el, tagName)) {
          return el
        }
        el = el.parentElement
      }
      return null
    },
    unwrapElement(el) {
      const parent = el.parentNode
      if (!parent) {
        return
      }
      while (el.firstChild) {
        parent.insertBefore(el.firstChild, el)
      }
      parent.removeChild(el)
    },
    cleanupEmptySpan(el) {
      if (el && el.tagName === 'SPAN' && !el.style.cssText && !el.className) {
        this.unwrapElement(el)
      }
    },
    toggleStyle(tagName, styles = {}) {
      const styleKeys = Object.keys(styles || {})
      if (SEMANTIC_COMMAND_MAP[tagName] && !styleKeys.length) {
        this.toggleStyleWithStyles(tagName, {}, false)
        return
      }
      if (styles['font-family'] === '默认') {
        this.toggleStyleWithStyles('span', styles, true)
        return
      }
      if (styles['font-size'] === '默认') {
        this.toggleStyleWithStyles('span', styles, false, true)
        return
      }
      this.toggleStyleWithStyles(tagName || 'span', styles, false)
    },
    toggleStyleWithStyles(tagName, styles, removeDefaultFont, removeDefaultFontSize) {
      this.restoreSelection()
      const selection = window.getSelection()
      if (!selection.rangeCount) {
        return
      }
      const range = selection.getRangeAt(0)
      const container = this.getEditorEl()
      if (!container || !container.contains(range.commonAncestorContainer)) {
        return
      }
      if (removeDefaultFont) {
        this.removeFontFamilyInRange(range)
        return
      }
      if (removeDefaultFontSize) {
        this.removeFontSizeInRange(range)
        return
      }
      if (!this.hasSelection(selection)) {
        return
      }
      const isAllStyled = this.checkIfAllStyled(range, tagName, styles)
      if (isAllStyled) {
        this.unwrapStyledText(range, tagName, styles)
      } else {
        this.wrapStyledText(range, tagName, styles)
      }
    },
    removeFontFamilyInRange(range) {
      const rangeBounds = this.captureRangeTextBounds(range)
      const container = this.getEditorEl()
      const processed = new Set()
      this.getTextNodesInRange(range).forEach(textNode => {
        let el = textNode.parentElement
        while (el && el !== container) {
          if (el.style && el.style.fontFamily && !processed.has(el)) {
            processed.add(el)
            el.style.removeProperty('font-family')
            this.cleanupEmptySpan(el)
          }
          el = el.parentElement
        }
      })
      this.applyRangeTextBounds(rangeBounds)
    },
    removeFontSizeInRange(range) {
      const rangeBounds = this.captureRangeTextBounds(range)
      const container = this.getEditorEl()
      const processed = new Set()
      this.getTextNodesInRange(range).forEach(textNode => {
        let el = textNode.parentElement
        while (el && el !== container) {
          if (el.style && el.style.fontSize && !processed.has(el)) {
            processed.add(el)
            el.style.removeProperty('font-size')
            this.cleanupEmptySpan(el)
          }
          el = el.parentElement
        }
      })
      this.applyRangeTextBounds(rangeBounds)
    },
    hasSelection(selection) {
      return selection.rangeCount > 0 && !selection.isCollapsed;
    },
    // 检查选区内是否所有文本都已应用指定样式
    checkIfAllStyled(range, tagName, styles) {
      const container = this.getEditorEl()
      const textNodes = this.getTextNodesInRange(range)
      if (!textNodes.length) {
        return false
      }
      return textNodes.every(node => this.findStyleElement(node, tagName, styles, container))
    },
    isStyleApplied(node, styles) {
      return this.elementMatchesStyles(node, styles)
    },
    wrapStyledText(range, tagName, styles) {
      const fragment = range.extractContents()
      if (styles && Object.keys(styles).length) {
        this.stripStylesFromFragment(fragment, styles)
      }
      const normalizedTag = (tagName || 'span').toLowerCase()
      if (normalizedTag === 'span') {
        const mergedNode = this.tryMergeStylesIntoSingleSpan(fragment, styles)
        if (mergedNode) {
          range.insertNode(mergedNode)
          this.selectNodeContents(mergedNode)
          return
        }
      }
      const wrapper = document.createElement(tagName || 'span')
      if (styles && Object.keys(styles).length) {
        this.applyInlineStyles(wrapper, styles)
      }
      wrapper.appendChild(fragment)
      range.insertNode(wrapper)
      this.selectNodeContents(wrapper)
    },
    tryMergeStylesIntoSingleSpan(fragment, styles) {
      if (!styles || !Object.keys(styles).length) {
        return null
      }
      const topNodes = Array.from(fragment.childNodes)
      if (topNodes.length !== 1) {
        return null
      }
      const node = topNodes[0]
      if (node.nodeType !== Node.ELEMENT_NODE || node.tagName !== 'SPAN') {
        return null
      }
      this.applyInlineStyles(node, styles)
      return node
    },
    stripStylesFromDescendants(root, styles) {
      if (!root || !styles) {
        return
      }
      Array.from(root.children).forEach(child => {
        this.stripStylesFromFragment(child, styles)
      })
    },
    stripStylesFromFragment(root, styles) {
      const elements = []
      if (root.nodeType === Node.ELEMENT_NODE) {
        elements.push(root)
      }
      const walker = document.createTreeWalker(root, NodeFilter.SHOW_ELEMENT)
      let node
      while ((node = walker.nextNode())) {
        elements.push(node)
      }
      elements.forEach(el => {
        let changed = false
        Object.keys(styles).forEach(key => {
          const prop = this.toCssProperty(key)
          if (el.style.getPropertyValue(prop)) {
            el.style.removeProperty(prop)
            changed = true
          }
        })
        if (changed) {
          this.cleanupEmptySpan(el)
        }
      })
    },
    unwrapStyledText(range, tagName, styles) {
      const hasStyles = styles && Object.keys(styles).length > 0
      const rangeBounds = this.captureRangeTextBounds(range)
      if (hasStyles) {
        const fragment = range.extractContents()
        const firstChild = fragment.firstChild
        const lastChild = fragment.lastChild
        this.stripStylesFromFragment(fragment, styles)
        range.insertNode(fragment)
        if (firstChild && lastChild) {
          const newRange = document.createRange()
          newRange.setStartBefore(firstChild)
          newRange.setEndAfter(lastChild)
          this.setSelectionRange(newRange)
        } else {
          this.applyRangeTextBounds(rangeBounds)
        }
        return
      }
      const container = this.getEditorEl()
      const processed = new Set()
      this.getTextNodesInRange(range).forEach(textNode => {
        const el = this.findStyleElement(textNode, tagName, null, container)
        if (!el || processed.has(el)) {
          return
        }
        processed.add(el)
        if (tagName && this.matchesTagName(el, tagName)) {
          this.unwrapElement(el)
        }
      })
      this.applyRangeTextBounds(rangeBounds)
    },

    // 添加样式
    applyInlineStyles(node, styles) {
      if (!styles || !node || !node.style) {
        return
      }
      Object.entries(styles).forEach(([key, value]) => {
        if (value == null || value === '') {
          return
        }
        node.style.setProperty(this.toCssProperty(key), value)
      })
    },

    // 移除样式
    removeInlineStyles(node, styles) {
      if (!styles || !node || !node.style) {
        return
      }
      Object.keys(styles).forEach(key => {
        node.style.removeProperty(this.toCssProperty(key))
      })
    },

  }
}
</script>
<style lang="scss" scoped>
@import "./MyEditor.scss";
</style>